import type { SVGProps } from 'react';

export default function Camera2(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.47505 7.2752H6.98672C7.58855 7.2752 8.15057 6.97441 8.48441 6.47366L9.21569 5.37673C9.54953 4.87598 10.1115 4.5752 10.7134 4.5752H13.2867C13.8886 4.5752 14.4506 4.87598 14.7844 5.37673L15.5157 6.47366C15.8495 6.97441 16.4115 7.2752 17.0134 7.2752H18.525C19.5192 7.2752 20.325 8.08108 20.325 9.0752V17.6252C20.325 18.6193 19.5192 19.4252 18.525 19.4252H5.47505C4.48094 19.4252 3.67505 18.6193 3.67505 17.6252V9.0752C3.67505 8.08108 4.48094 7.2752 5.47505 7.2752Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.925 12.9002C14.925 14.5156 13.6155 15.8252 12 15.8252C10.3846 15.8252 9.07505 14.5156 9.07505 12.9002C9.07505 11.2848 10.3846 9.9752 12 9.9752C13.6155 9.9752 14.925 11.2848 14.925 12.9002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
